// ТРАНСПОРТ СЛЕПКА — клиентская половина `api/snapshot.js` (Supabase, часть 1). Форма — как у
// `transport.js`: `fetchImpl` подставляется, НЕ БРОСАЕТ НИКОГДА, повторов нет, исход `{ ok, reason }`.
// ⛔ Токен в `reason` не кладётся.

import { SNAPSHOT_PATH, SNAPSHOT_SCHEMA_VERSION } from '../share/snapshot.js';

/** Граница одного запроса слепка: сохранение идёт в счёт тех же 30 с, что и письмо. */
export const SNAPSHOT_TIMEOUT_MS = 15_000;

async function bounded(fetchImpl, url, init, timeoutMs) {
  const ac = typeof AbortController !== 'undefined' ? new AbortController() : null;
  let timer = null;
  try {
    return await Promise.race([
      fetchImpl(url, { ...init, ...(ac ? { signal: ac.signal } : {}) }),
      new Promise((resolve) => { timer = setTimeout(() => { ac?.abort(); resolve(null); }, timeoutMs); }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}

/**
 * Сохранить слепок под токеном. `{ saved: true }` — строка есть (новая или та же при повторе).
 * @returns {Promise<{saved:boolean, reason:string}>}
 */
export async function saveSnapshot(token, snapshot, {
  endpoint = SNAPSHOT_PATH, fetchImpl = globalThis.fetch, timeoutMs = SNAPSHOT_TIMEOUT_MS,
} = {}) {
  if (typeof fetchImpl !== 'function') return { saved: false, reason: 'no_fetch' };
  try {
    const resp = await bounded(fetchImpl, endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, schemaVersion: SNAPSHOT_SCHEMA_VERSION, snapshot }),
    }, timeoutMs);
    if (!resp) return { saved: false, reason: `timeout_${timeoutMs}ms` };
    if (!resp.ok) return { saved: false, reason: `http_${resp.status}` };
    return { saved: true, reason: 'ok' };
  } catch {
    return { saved: false, reason: 'network' };
  }
}

/**
 * Слепок по токену. `not_found` — честное «такой ссылки нет» (неизвестный и просроченный неразличимы);
 * остальное — сбой связи или сервера.
 * @returns {Promise<{ok:true, snapshot:object} | {ok:false, reason:string}>}
 */
export async function loadSnapshot(token, {
  endpoint = SNAPSHOT_PATH, fetchImpl = globalThis.fetch, timeoutMs = SNAPSHOT_TIMEOUT_MS,
} = {}) {
  if (typeof fetchImpl !== 'function') return { ok: false, reason: 'no_fetch' };
  try {
    const resp = await bounded(fetchImpl, `${endpoint}?token=${encodeURIComponent(token)}`, { method: 'GET' }, timeoutMs);
    if (!resp) return { ok: false, reason: `timeout_${timeoutMs}ms` };
    if (resp.status === 404) return { ok: false, reason: 'not_found' };
    if (!resp.ok) return { ok: false, reason: `http_${resp.status}` };
    const data = await resp.json();
    if (data?.schemaVersion !== SNAPSHOT_SCHEMA_VERSION || !data.snapshot?.passport) return { ok: false, reason: 'unknown_schema_version' };
    return { ok: true, snapshot: data.snapshot };
  } catch {
    return { ok: false, reason: 'network' };
  }
}
